import { Trans, useTranslation } from 'react-i18next';
import { IoMdHelpCircleOutline } from 'react-icons/io';
import { Button } from '@heroui/button';
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from '@heroui/modal';

function ProgressionHelp() {
  const { t } = useTranslation();
  const {isOpen, onOpen, onOpenChange} = useDisclosure();

  return (
    <div className="mb-8 sm:my-8 sm:max-w-1/3">
      <Button
        size="md"
        startContent={<IoMdHelpCircleOutline />}
        variant="ghost"
        onPress={onOpen}
      >
        {t('progression.help.title')}
      </Button>
      <Modal
        backdrop="blur"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        <ModalContent className="bg-default-50 text-foreground">
          <ModalHeader>{t('progression.help.title')}</ModalHeader>
          <ModalBody>
            <div className="flex flex-col gap-3 pb-4">
              <Trans
                components={{
                  p: <p />,
                }}
                i18nKey="progression.help.content"
              />
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}

export default ProgressionHelp;
